export class VendaResposta {
  idCupom: string;
  idPergunta: number;
  respostaSN: string;
  respostaTexto: string;
  tipoQuest: number;
}
